import React from 'react';

type Props = {
    size            : 'large' | 'big' | 'normal' | 'small' | 'smaller' | 'tiny'
    className?      : string
    organization    : any
    renderNoIcon?   : 'image' | 'icon'
}

export default function OrganizationIcon(props:Props) {

    const size = props.size || 'normal'
    const renderNoIcon = props.renderNoIcon || 'image'


    const { mediaPath } = gdConfig;
    let iconPath, sizeClass;

    let iconFile = props.organization ? props.organization.icon : null;

    if (!iconFile && renderNoIcon === 'image') iconFile = '_def.png';

    if (iconFile === '_def.png' && renderNoIcon === 'icon') iconFile=null;

    switch (size) {
        case 'large':
            iconPath = mediaPath + "company/large/"+iconFile;
            sizeClass = "icon-large";
            break;
        case 'big':
            iconPath = mediaPath + "company/large/"+iconFile;
            sizeClass = "icon-big";
            break;
        case 'normal':
            iconPath = mediaPath + "company/norm/"+iconFile;
            sizeClass = "icon-normal";
            break;
        case 'small':
            iconPath = mediaPath + "company/norm/"+iconFile;
            sizeClass = "icon-small";
            break;
        case 'smaller':
            iconPath = mediaPath + "company/norm/"+iconFile;
            sizeClass = "icon-smaller";
            break;
        case 'tiny':
            iconPath = mediaPath + "company/small/"+iconFile;
            sizeClass = "icon-tiny";
            break;

        default:
            console.error("unknown size");
            return null;
    }

    let classes;

    if (iconFile) {
        classes = Classes('gd-organization-icon', props.className, sizeClass);
        return <img src={iconPath} alt='' className={classes}/>;
    } else {
        classes = Classes('gd-organization-icon', "i5-organization", props.className, sizeClass);
        return <div className={classes}/>;
    }

}